import { Button } from 'antd';

import { PF } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/data';

const TABLE = `${PF}_products-table`;

interface Props {
  submitLabel: string;
  isLoading: boolean;
  isSubmitDisabled?: boolean;
  onReset: () => void;
}

export const OperationFormButtons = ({
  submitLabel,
  isLoading,
  isSubmitDisabled,
  onReset,
}: Props) => (
  <div className={`${TABLE}_buttons`}>
    <Button
      type="primary"
      htmlType="submit"
      className={`${TABLE}_buttons_item`}
      disabled={isLoading || isSubmitDisabled}
    >
      {submitLabel}
    </Button>
    <Button
      onClick={onReset}
      className={`${TABLE}_buttons_item`}
      disabled={isLoading}
    >
      Сбросить
    </Button>
  </div>
);
